module.exports = __webpack_public_path__ + "static/2-80655c91e0f72e9e0522a4fbb8ef3aee.png";